import { api } from "@/shared/api";

// local-only: 1010 客服 H5 端契约 §1(docs/2026-10-10-客服H5端/任务书.md)+ 一期补完契约 4(avatarUrl),codegen 尚未覆盖。
export type WebEntryUpsert = {
  /** 接入点名 1–32 字,会话列表显示来源用 */
  name: string;
  /** ≤16,空 = 「智能客服」 */
  agentName?: string;
  /** ≤200,空 = 回落:租户欢迎语(企微页签设置)→ 默认欢迎语 */
  welcomeText?: string;
  /** ≤6 条,每条 ≤30 字 */
  quickQuestions?: string[];
  /** #RRGGBB,空 = #2F5BD3 */
  themeColor?: string;
  leadEnabled?: boolean;
  enabled?: boolean;
  /**
   * 1010 一期补完契约 4:接入点头像(空 = 内置机器人图)。
   * console 经 `/poster/uploads`(kind=logo,不受视觉舱门)上传,写入的是**私有桶 objectKey**;
   * 公开 `/config` 读取时由 api presign。也兼容 http(s) 绝对地址(api 若直接存公开 URL)。
   */
  avatarUrl?: string;
};

export type WebEntryDto = Required<Omit<WebEntryUpsert, "avatarUrl">> & {
  /** 存的原值(objectKey 或绝对 URL);空 / 缺省 = 内置机器人图。 */
  avatarUrl?: string | null;
  /** 可选:api 给的短时预览地址(avatarUrl 是私有 key 时用它显示);没有则前端按 avatarUrl 是否绝对地址决定能否预览。 */
  avatarPreviewUrl?: string | null;
  id: string;
  entryKey: string;
  /** 以 `/` 开头 = 相对路径(后端没配 cs.web.public-base-url),前端拼 window.location.origin */
  h5Url: string;
  embedCode: string;
  sessionCount7d: number;
  createdAt: string;
};

export const WEB_ENTRY_LIMITS = {
  name: 32,
  agentName: 16,
  welcomeText: 200,
  quickQuestions: 6,
  quickQuestion: 30,
} as const;

export const DEFAULT_THEME_COLOR = "#2F5BD3";

const BASE = "/tenant/customer-service/web-entries";

/** 相对地址补成绝对地址(二维码 / 复制链接必须是完整 URL)。 */
export function absolutizeUrl(url: string, origin = window.location.origin): string {
  if (!url) return url;
  return url.startsWith("/") ? `${origin}${url}` : url;
}

/** 嵌入代码里的相对 src 同样补 origin(`src="/widget/v1.js"` → `src="https://…/widget/v1.js"`)。 */
export function absolutizeEmbedCode(code: string, origin = window.location.origin): string {
  if (!code) return code;
  return code.replace(/src="(\/[^"]*)"/g, (_m, p: string) => `src="${origin}${p}"`);
}

export const webEntryService = {
  list: () => api.get<WebEntryDto[]>(BASE),
  create: (body: WebEntryUpsert) => api.post<WebEntryDto>(BASE, body),
  update: (id: string, body: WebEntryUpsert) =>
    api.put<WebEntryDto>(`${BASE}/${encodeURIComponent(id)}`, body),
  remove: (id: string) => api.delete<void>(`${BASE}/${encodeURIComponent(id)}`),
  rotateKey: (id: string) =>
    api.post<WebEntryDto>(`${BASE}/${encodeURIComponent(id)}/rotate-key`, {}),
};
